import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
const painPoints = ['Sentís que no sabés qué darle de comer a tu perro y te da miedo hacerlo mal', 'Te preocupa que el alimento balanceado no sea lo mejor, pero no sabés cómo reemplazarlo', 'Querés darle comida natural, pero no sabés por dónde empezar', 'Tenés miedo de equivocarte con sus comidas', 'Querés darle lo mejor, pero necesitás algo simple, claro y seguro'];
export function ProblemSection() {
  return <section className="py-20 px-4 bg-lightgreen" data-id="element-193">
      <div className="max-w-4xl mx-auto" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-196">
            Este ebook es para vos si…
          </h2>
          <div className="w-20 h-1 bg-accent mx-auto rounded-full" data-id="element-197"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-198">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start p-5 bg-white rounded-xl shadow-sm border border-sage hover:shadow-md transition-shadow" data-id="element-199">
              <div className="flex-shrink-0 mt-1" data-id="element-200">
                <AlertCircleIcon className="w-6 h-6 text-accent" data-id="element-201" />
              </div>
              <p className="ml-4 text-lg text-gray-700 font-medium" data-id="element-202">{point}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}